// extracted by mini-css-extract-plugin
module.exports = {"chartContainer":"total-clients-chart_chartContainer__NrhQZ","header":"total-clients-chart_header__2TZGD"};